// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MarketplacePage {
  width: 100%;
  min-height: 100vh;
}

/* Hero Banner */
.mp-hero-banner {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  padding: 28px 24px;
  margin-bottom: 24px;
}

.mp-hero-title {
  font-family: "Inter", sans-serif;
  font-size: 26px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 8px 0;
  line-height: normal;
}

.mp-hero-sub {
  font-family: "Inter", sans-serif;
  font-size: 14px;
  color: #777777;
  margin: 0 0 20px 0;
  line-height: normal;
  max-width: 600px;
}

/* Search Bar */
.mp-search-bar {
  display: flex;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 10px;
  padding: 10px 16px;
  max-width: 650px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;
}

.mp-search-bar:focus-within {
  border-color: #48d1cc;
}

.mp-search-icon {
  margin-right: 12px;
  font-size: 16px;
  color: #48d1cc;
}

.mp-search-input {
  flex: 1 1;
  background: transparent;
  border: none;
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 14px;
  outline: none;
}

.mp-search-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.mp-search-clear {
  background: transparent;
  border: none;
  color: #777777;
  font-size: 18px;
  cursor: pointer;
  padding: 0 4px;
}

.mp-search-clear:hover {
  color: #ffffff;
}

/* Category Pills */
.mp-category-pills {
  display: flex;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 8px;
  margin-bottom: 20px;
}

.mp-category-pill {
  font-family: "Inter", sans-serif;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #777777;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s ease;
}

.mp-category-pill:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.06);
}

.mp-category-pill--active {
  background-color: #3bb3ae !important;
  border-color: #3bb3ae !important;
  color: #071414 !important;
  font-weight: 700 !important;
}

/* Secondary Controls Row */
.mp-controls-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 20px;
  margin-bottom: 24px;
}

.mp-filter-group {
  display: flex;
  align-items: center;
  gap: 10px;
}

.mp-filter-label {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #777777;
  white-space: nowrap;
}

/* Constrain the CustomDropdown width inside filter groups */
.mp-filter-group .custom-dropdown-container {
  min-width: 155px;
  width: auto;
}

.mp-select {
  font-family: "Inter", sans-serif;
  background: #0e1b1b;
  border: 1px solid rgba(255, 255, 255, 0.15);
  color: #ffffff;
  padding: 6px 12px;
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  cursor: pointer;
}

.mp-select option {
  background-color: #0e1b1b;
  color: #ffffff;
}

/* Marketplace Cards Grid */
.mp-grid-container {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.mp-card {
  background-color: #0e1b1b;
  border: 1.5px solid rgba(255, 255, 255, 0.07);
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
}

.mp-card:hover {
  transform: translateY(-3px);
  border-color: rgba(59, 179, 174, 0.3);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);
}

.mp-card__thumbnail-wrap {
  position: relative;
  height: 160px;
  width: 100%;
  overflow: hidden;
}

.mp-card__img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.3s ease;
}

.mp-card:hover .mp-card__img {
  transform: scale(1.04);
}

.mp-card__category-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(4px);
  color: #48d1cc;
  font-family: "Inter", sans-serif;
  font-size: 10px;
  font-weight: 700;
  padding: 3px 8px;
  border-radius: 4px;
  text-transform: uppercase;
}

.mp-card__delivery-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background: rgba(0, 0, 0, 0.65);
  backdrop-filter: blur(4px);
  color: #ffffff;
  font-family: "Inter", sans-serif;
  font-size: 10px;
  padding: 3px 8px;
  border-radius: 4px;
}

.mp-card__content {
  padding: 16px;
  display: flex;
  flex-direction: column;
  flex: 1 1;
}

.mp-card__title {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #ffffff;
  margin: 0 0 6px 0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.mp-card__snippet {
  font-family: "Inter", sans-serif;
  font-size: 13px;
  color: #777777;
  margin: 0 0 16px 0;
  line-height: 1.5;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  flex: 1 1;
}

.mp-card__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 12px;
  border-top: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom: 14px;
}

.mp-card__provider {
  display: flex;
  align-items: center;
  gap: 8px;
}

.mp-card__avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  object-fit: cover;
}

.mp-card__provider-name {
  font-family: "Inter", sans-serif;
  font-size: 12px;
  color: #ffffff;
}

.mp-card__price {
  font-family: "Inter", sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #48d1cc;
}

.mp-card__btn-book {
  width: 100%;
  background-color: #3bb3ae;
  border: none;
  color: #071414;
  padding: 9px;
  border-radius: 8px;
  font-family: "Inter", sans-serif;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
  transition: opacity 0.2s ease;
}

.mp-card__btn-book:hover {
  opacity: 0.88;
}`, "",{"version":3,"sources":["webpack://./src/Pages/MarketplacePage/MarketplacePage.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;EAChC,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA,4DAA4D;AAC5D;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,2CAA2C;EAC3C,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,6CAA6C;EAC7C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,6EAA6E;AAC/E;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,+BAA+B;EAC/B,0BAA0B;EAC1B,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,+BAA+B;EAC/B,0BAA0B;EAC1B,cAAc;EACd,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAO;AACT;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;EAChB,SAAO;AACT;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf","sourcesContent":[".MarketplacePage {\n  width: 100%;\n  min-height: 100vh;\n}\n\n/* Hero Banner */\n.mp-hero-banner {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  padding: 28px 24px;\n  margin-bottom: 24px;\n}\n\n.mp-hero-title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 26px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 8px 0;\n  line-height: normal;\n}\n\n.mp-hero-sub {\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  color: #777777;\n  margin: 0 0 20px 0;\n  line-height: normal;\n  max-width: 600px;\n}\n\n/* Search Bar */\n.mp-search-bar {\n  display: flex;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  border-radius: 10px;\n  padding: 10px 16px;\n  max-width: 650px;\n  transition: border-color 0.2s ease;\n  box-sizing: border-box;\n}\n\n.mp-search-bar:focus-within {\n  border-color: #48d1cc;\n}\n\n.mp-search-icon {\n  margin-right: 12px;\n  font-size: 16px;\n  color: #48d1cc;\n}\n\n.mp-search-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 14px;\n  outline: none;\n}\n\n.mp-search-input::placeholder {\n  color: rgba(255, 255, 255, 0.4);\n}\n\n.mp-search-clear {\n  background: transparent;\n  border: none;\n  color: #777777;\n  font-size: 18px;\n  cursor: pointer;\n  padding: 0 4px;\n}\n\n.mp-search-clear:hover {\n  color: #ffffff;\n}\n\n/* Category Pills */\n.mp-category-pills {\n  display: flex;\n  gap: 8px;\n  overflow-x: auto;\n  padding-bottom: 8px;\n  margin-bottom: 20px;\n}\n\n.mp-category-pill {\n  font-family: \"Inter\", sans-serif;\n  background: rgba(255, 255, 255, 0.03);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  color: #777777;\n  padding: 8px 16px;\n  border-radius: 20px;\n  font-size: 13px;\n  font-weight: 500;\n  cursor: pointer;\n  white-space: nowrap;\n  transition: all 0.2s ease;\n}\n\n.mp-category-pill:hover {\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.mp-category-pill--active {\n  background-color: #3bb3ae !important;\n  border-color: #3bb3ae !important;\n  color: #071414 !important;\n  font-weight: 700 !important;\n}\n\n/* Secondary Controls Row */\n.mp-controls-row {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 20px;\n  margin-bottom: 24px;\n}\n\n.mp-filter-group {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.mp-filter-label {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #777777;\n  white-space: nowrap;\n}\n\n/* Constrain the CustomDropdown width inside filter groups */\n.mp-filter-group .custom-dropdown-container {\n  min-width: 155px;\n  width: auto;\n}\n\n.mp-select {\n  font-family: \"Inter\", sans-serif;\n  background: #0e1b1b;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  color: #ffffff;\n  padding: 6px 12px;\n  border-radius: 6px;\n  font-size: 13px;\n  outline: none;\n  cursor: pointer;\n}\n\n.mp-select option {\n  background-color: #0e1b1b;\n  color: #ffffff;\n}\n\n/* Marketplace Cards Grid */\n.mp-grid-container {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 20px;\n}\n\n.mp-card {\n  background-color: #0e1b1b;\n  border: 1.5px solid rgba(255, 255, 255, 0.07);\n  border-radius: 12px;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  transition: transform 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.mp-card:hover {\n  transform: translateY(-3px);\n  border-color: rgba(59, 179, 174, 0.3);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3);\n}\n\n.mp-card__thumbnail-wrap {\n  position: relative;\n  height: 160px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.mp-card__img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transition: transform 0.3s ease;\n}\n\n.mp-card:hover .mp-card__img {\n  transform: scale(1.04);\n}\n\n.mp-card__category-badge {\n  position: absolute;\n  top: 10px;\n  left: 10px;\n  background: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(4px);\n  color: #48d1cc;\n  font-family: \"Inter\", sans-serif;\n  font-size: 10px;\n  font-weight: 700;\n  padding: 3px 8px;\n  border-radius: 4px;\n  text-transform: uppercase;\n}\n\n.mp-card__delivery-badge {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  background: rgba(0, 0, 0, 0.65);\n  backdrop-filter: blur(4px);\n  color: #ffffff;\n  font-family: \"Inter\", sans-serif;\n  font-size: 10px;\n  padding: 3px 8px;\n  border-radius: 4px;\n}\n\n.mp-card__content {\n  padding: 16px;\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.mp-card__title {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #ffffff;\n  margin: 0 0 6px 0;\n  line-height: 1.3;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n\n.mp-card__snippet {\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  color: #777777;\n  margin: 0 0 16px 0;\n  line-height: 1.5;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  flex: 1;\n}\n\n.mp-card__footer {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding-top: 12px;\n  border-top: 1px solid rgba(255, 255, 255, 0.05);\n  margin-bottom: 14px;\n}\n\n.mp-card__provider {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.mp-card__avatar {\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.mp-card__provider-name {\n  font-family: \"Inter\", sans-serif;\n  font-size: 12px;\n  color: #ffffff;\n}\n\n.mp-card__price {\n  font-family: \"Inter\", sans-serif;\n  font-size: 16px;\n  font-weight: 700;\n  color: #48d1cc;\n}\n\n.mp-card__btn-book {\n  width: 100%;\n  background-color: #3bb3ae;\n  border: none;\n  color: #071414;\n  padding: 9px;\n  border-radius: 8px;\n  font-family: \"Inter\", sans-serif;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n  transition: opacity 0.2s ease;\n}\n\n.mp-card__btn-book:hover {\n  opacity: 0.88;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
